@let currentDraft = draft();

<h3 class="text-[0.75rem] font-semibold leading-[150%] text-(--p-blue-300) mb-2">{{ '@@fp-event-panel__investigation-result' | translate }}</h3>

@if (!hasResult()) {
  <div class="flex flex-1 min-h-[8rem] mdmb-13 flex-col items-center justify-center gap-[0.5rem] rounded-[0.5rem] bg-(--p-other-gray-50) px-4 text-center">
    <p class="text-[0.75rem] font-semibold leading-[150%] text-(--p-gray-500) max-w-[18.75rem]"
       translate="@@fp-event-result-empty__title"></p>

    <p class="text-[0.6875rem] font-medium leading-[150%] text-(--p-gray-500) max-w-[18.75rem]"
       translate="@@fp-event-result-empty__description"></p>
  </div>
} @else {
  <div class="flex flex-col flex-grow mb-13 rounded-[0.5rem] border overflow-hidden" [class]="panelBorder()">
    <div class="flex items-center gap-[0.5rem] px-[0.75rem] py-[0.75rem] text-(--p-gray-950)" [class]="panelTheme()">
      <gc-icon-badge [iconSrc]="resultIcon() ?? ''"
                     [alt]="resultLabel()"
                     [overlayIconSrc]="repairOverlayIcon()"
                     size="1.75rem"></gc-icon-badge>

      <span class="flex-1 min-w-0 text-[0.6875rem] font-medium leading-none" [translate]="resultLabel()"></span>

      <p-button icon="true"
                severity="secondary"
                class="flex shrink-0"
                styleClass="!size-[1.75rem] !rounded-[0.25rem] !border !border-transparent !p-0 !bg-(--p-surface-0) !text-(--p-blue-500) enabled:hover:!bg-(--p-neutral-500) enabled:hover:!border-(--p-blue-100)"
                [ariaLabel]="'@@shared-edit__text' | translate"
                (onClick)="editResult()">
        <svg-icon src="icons/icon-edit.svg" name="icon-edit" class="size-[1.25rem] shrink-0"></svg-icon>
      </p-button>
    </div>

    <div class="flex flex-col gap-[1rem] bg-(--p-surface-0) px-[0.75rem] py-[1.25rem]">
      <!-- the columns are as wide as what they hold, the way the design spaces them out -->
      <div class="flex flex-wrap items-start gap-x-[1.5rem] gap-y-[0.75rem]">
        @if (!dialogState.isResolvedAsNoLeak()) {
          <div class="flex flex-col gap-1">
            <span class="text-[0.75rem] font-semibold leading-[150%] text-(--p-gray-950)">
              {{ leakSizeDisplay() }}

              @if (leakSizeUnitLabel(); as unit) {
                <span [translate]="unit"></span>
              }
            </span>

            <span class="text-[0.6875rem] leading-[150%] text-(--p-gray-500)"
                  translate="@@fp-event-field__leak-size"></span>
          </div>
        } @else {
          <div class="flex flex-col gap-1">
            <span class="text-[0.75rem] font-semibold leading-[150%] text-(--p-gray-950)">
              {{ nonLeakLabel() ? (nonLeakLabel() | translate) : noData }}

              @if (currentDraft.nonLeakOtherDetails) {
                <span class="text-[0.75rem] font-medium text-(--p-gray-500)">({{ currentDraft.nonLeakOtherDetails }})</span>
              }
            </span>

            <span class="text-[0.6875rem] leading-[150%] text-(--p-gray-500)"
                  translate="@@fp-event-field__non-leak-details"></span>
          </div>
        }

        <div class="flex flex-col gap-1">
          <span class="text-[0.75rem] font-semibold leading-[150%] text-(--p-gray-950)">
            {{ pressureDisplay() }}

            @if (pressureUnitLabel(); as unit) {
              <span [translate]="unit"></span>
            }
          </span>

          <span class="text-[0.6875rem] leading-[150%] text-(--p-gray-500)"
                translate="@@fp-event-field__pressure"></span>
        </div>

        <div class="flex flex-col gap-1">
          <span class="text-[0.75rem] text-(--p-gray-950) font-semibold leading-[150%]">{{ soilLabel() ? (soilLabel() | translate) : noData }}</span>

          <span class="text-[0.6875rem] leading-[150%] text-(--p-gray-500)"
                translate="@@fp-event-field__soil-composition"></span>

        </div>
    </div>

      @if (repairDateLabel()) {
        <div class="h-[1px] mt-1 w-full bg-(--p-primary-50)"></div>

        <div class="flex items-center gap-[0.25rem]">
          <svg-icon src="icons/icon-tab-events.svg"
                    name="icon-tab-events"
                    class="size-[1.125rem] shrink-0 text-(--p-gray-500)"></svg-icon>

          <span class="text-[0.6875rem] font-medium leading-none text-(--p-gray-500)" [translate]="repairDateLabel()!"></span>

          <span class="text-[0.75rem] font-semibold leading-[150%] text-(--p-gray-950)">
            {{ (currentDraft.repairDate ?? undefined) | dayjs: dateFormat }}
          </span>
        </div>
      }
    </div>
  </div>
}
